import React, { useState } from 'react';
import { Hero } from './components/Hero';
import { PainSection } from './components/PainSection';
import { Solution } from './components/Solution';
import { InsideList } from './components/InsideList';
import { WhyItWorks } from './components/WhyItWorks';
import { ImagineSection } from './components/ImagineSection';
import { Testimonials } from './components/Testimonials';
import { Bonuses } from './components/Bonuses';
import { OfferStack } from './components/OfferStack';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
import { LegalModal } from './components/LegalModal';
import { StickyBar } from './components/StickyBar';
import type { LegalDoc } from './data/legal';
export function App() {
  const [activeDoc, setActiveDoc] = useState<LegalDoc | null>(null);
  return <div className="w-full bg-cream font-sans text-ink" data-id="element-0" data-mp="23vciyq2516ak">
      <Hero data-id="element-1" data-mp="23ujha3i1d6za" />
      <main data-id="element-2" data-mp="23v2sz2h3ez4v">
        <PainSection data-id="element-3" data-mp="23t8eo70bu59r" />
        <Solution data-id="element-4" data-mp="3ik7fqfdqo9q4" />
        <InsideList data-id="element-5" data-mp="3ikqyfyb7r257" />
        <WhyItWorks data-id="element-6" data-mp="3ij65gd4jrr9g" />
        <ImagineSection data-id="element-7" data-mp="3ihv1odb3qjic" />
        <Testimonials data-id="element-8" data-mp="3mlj8uuvtnd32" />
        <Bonuses data-id="element-9" data-mp="3mkre1ma1tjdu" />
        <OfferStack data-id="element-10" data-mp="3mk85uxa7a9d0" />
        <Faq data-id="element-11" data-mp="3mjq3diwy2ywn" />
        <FinalCta data-id="element-12" data-mp="3mj6ipufwtwex" />
      </main>
      <Footer onOpenDoc={setActiveDoc} data-id="element-13" data-mp="3rbrayrj641gc" />
      <StickyBar data-id="element-14" data-mp="3rcswxr1q28cu" />
      <LegalModal doc={activeDoc} onClose={() => setActiveDoc(null)} data-id="element-15" data-mp="3reccfffk0fdk" />
    </div>;
}